import styled from 'styled-components';
import { MContentHeaderAlignment } from './MContentHeader.types';

export const ContentHeaderWrapper = styled.div<{ alignment?: MContentHeaderAlignment }>`
  margin-bottom: 2rem;
  text-align: ${props => (props.alignment === MContentHeaderAlignment.Centered ? 'center' : 'left')};

  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    text-align: left;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;
